import { createRequestConstantNames } from 'store/util/createConstants';
import cc from 'store/util/createReduxConstant';

export const [
  FETCH_RESERVATION_HISTORY_BY_ACCOUNT,
  FETCH_RESERVATION_HISTORY_BY_ACCOUNT_SUCCESS,
  FETCH_RESERVATION_HISTORY_BY_ACCOUNT_FAIL,
] = createRequestConstantNames(cc('FETCH_RESERVATION_HISTORY_BY_ACCOUNT'));
